// extracted by mini-css-extract-plugin
export var downArrow = "_95-0";
export var infoTooltipIcon = "_95-3";
export var label = "_95-1";
export var optionCard = "_95-4";
export var upArrow = "_95-2";